<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      @if (!locationSelected) {
        <h1 class="title">Crear ubicación</h1>
      }
    </div>
    <div class="title-color">
      @if (locationSelected) {
        <h1 class="title">Editar ubicación</h1>
      }
    </div>
    <div class="form-body">
      <form [formGroup]="locationForm" (ngSubmit)="saveLocation()">
        <div class="line">
          <div class="form-grid cols-2">
            <mat-form-field appearance="outline">
              <mat-label>Código del país</mat-label>
              <input
                type="text"
                matInput
                placeholder="Código del país"
                formControlName="countryCode"
                maxlength="50"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (locationForm.get('countryCode')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (locationForm.get('countryCode')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 50 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>País</mat-label>
              <input
                type="text"
                matInput
                placeholder="País"
                formControlName="country"
                maxlength="50"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (locationForm.get('country')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (locationForm.get('country')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 50 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Código de Departamento</mat-label>
              <input
                type="text"
                matInput
                placeholder="Código de Departamento"
                formControlName="departmentCode"
                required
                maxlength="10"
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (locationForm.get('departmentCode')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (locationForm.get('departmentCode')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 10 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Departamento</mat-label>
              <input
                type="text"
                matInput
                placeholder="Departamento"
                formControlName="department"
                required
                maxlength="10"
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (locationForm.get('department')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (locationForm.get('department')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 10 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Código de Ciudad</mat-label>
              <input
                type="text"
                matInput
                placeholder="Código de Ciudad"
                formControlName="cityCode"
                required
                maxlength="10"
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (locationForm.get('cityCode')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (locationForm.get('cityCode')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 10 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label> Ciudad</mat-label>
              <input
                type="text"
                matInput
                placeholder="Ciudad"
                formControlName="city"
                required
                maxlength="100"
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (locationForm.get('city')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (locationForm.get('city')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 100 caracteres
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <button type="submit" class="primary-button" [disabled]="!locationForm.touched">
          <span class="button-content"> <mat-icon fontIcon="save"></mat-icon>Guardar </span>
        </button>

        <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
          <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
        </button>
      </form>
    </div>
  </div>
</div>
